import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function UploadIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 16V4M7 9l5-5 5 5" />
      <path d="M4 20h16" />
    </svg>
  );
}

export class CargarMesas extends Component {
  static displayName = CargarMesas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      successMessage: '',
      base64: '',
      fileName: '',
    };
    this.fileInputRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWMesaExamen');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.successMessage) {
      this.setState({ errorMessage: '', successMessage: '' });
    }
  }

  handleFileChange = (e) => {
    this.clearFeedback();
    const file = e.target.files && e.target.files[0];

    if (!file) {
      this.setState({ base64: '', fileName: '' });
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result || '';
      const parts = String(result).split(',');
      const base64 = parts.length > 1 ? parts[1] : '';
      if (!base64) {
        this.setState({
          base64: '',
          fileName: '',
          errorMessage: 'No se pudo leer el archivo seleccionado.',
        });
        return;
      }
      this.setState({ base64, fileName: file.name, errorMessage: '' });
    };
    reader.onerror = (error) => {
      this.setState({
        base64: '',
        fileName: '',
        errorMessage: 'Error al leer el archivo: ' + error,
      });
    };
  };

  handleReset = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
    this.setState({
      base64: '',
      fileName: '',
      errorMessage: '',
      successMessage: '',
    });
  };

  isOkToSave() {
    return this.state.base64.length > 1;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios' });
      return;
    }

    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/mex/archivo', {
      method: 'POST',
      body: JSON.stringify({
        Archivo: this.state.base64,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar las mesas de examen. Verifique el archivo e intente nuevamente.'
        ),
      });
      return;
    }

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }

    this.setState({
      loading: false,
      base64: '',
      fileName: '',
      successMessage: 'Generación de Mesas de Examen exitosa',
    });
  }

  render() {
    const { loading, errorMessage, successMessage, fileName } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-mex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Cargar Mesas de Examen</h1>
        <p className="md-form-page__subtitle">
          Seleccione el archivo con las mesas de examen a importar.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {successMessage ? <span className="md-form-page__success">{successMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Generando mesas de examen, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="cme-archivo">
                Archivo de mesas
              </label>
              <div className="md-form-page__file-wrap">
                <input
                  ref={this.fileInputRef}
                  id="cme-archivo"
                  className="md-form-page__file-input"
                  type="file"
                  onChange={this.handleFileChange}
                  disabled={isBusy}
                />
                <p
                  className={
                    'md-form-page__file-name' + (fileName ? '' : ' md-form-page__file-name--empty')
                  }
                >
                  {fileName || 'Ningún archivo seleccionado'}
                </p>
              </div>
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                <UploadIcon />
                Cargar mesas
              </button>
              <button
                type="button"
                className="md-form-page__btn md-form-page__btn--secondary"
                onClick={this.handleReset}
                disabled={isBusy}
              >
                Limpiar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
